import { useCallback, useState } from 'react';
import { ToastType } from 'src/components/atoms/CustomToast';

type ToastState = {
  isOpen: boolean;
  title: string;
  description: string;
  type: ToastType;
};

const initialToastState: ToastState = {
  isOpen: false,
  title: '',
  description: '',
  type: 'success',
};

export const useCustomToast = () => {
  const [toastState, setToastState] = useState<ToastState>(initialToastState);

  const showToast = useCallback(
    (title: string, description: string, type: ToastType = 'success') => {
      setToastState({
        isOpen: true,
        title,
        description,
        type,
      });
    },
    [],
  );

  const hideToast = useCallback(() => {
    setToastState((prev) => ({
      ...prev,
      isOpen: false,
    }));
  }, []);

  const showSuccess = useCallback(
    (title: string, description: string) => {
      showToast(title, description, 'success');
    },
    [showToast],
  );

  const showError = useCallback(
    (title: string, description: string) => {
      showToast(title, description, 'error');
    },
    [showToast],
  );

  const showWarning = useCallback(
    (title: string, description: string) => {
      showToast(title, description, 'warning');
    },
    [showToast],
  );

  const showInfo = useCallback(
    (title: string, description: string) => {
      showToast(title, description, 'info');
    },
    [showToast],
  );

  return {
    toastState,
    showToast,
    hideToast,
    showSuccess,
    showError,
    showWarning,
    showInfo,
  };
};
